/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_2_CInputs */

const en_mk_how_2_c = /** @type {(inputs: Mk_How_2_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose when results need your approval`)
};

const id_mk_how_2_c = /** @type {(inputs: Mk_How_2_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentukan kapan hasil perlu persetujuanmu`)
};

/**
* | output |
* | --- |
* | "Choose when results need your approval" |
*
* @param {Mk_How_2_CInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_2_c = /** @type {((inputs?: Mk_How_2_CInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_2_CInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_2_c(inputs)
	return en_mk_how_2_c(inputs)
});